import React, { Component, Fragment } from 'react';
import { isEmpty } from "lodash";
import { Dialog, DialogTitle, DialogContent, IconButton, Grid, Table, TableBody, TableRow, TableCell, TableHead, Divider } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import SpendingDetails from '../../Spendings/SpendingDetails';
import Currency from '../../common/Currency';
import { MONTHS } from '../../../utils/generalFuncs';

class PaymentDetails extends Component {
    state = {  
        payments: [],
        openSpending: "", 
        spending: {}, 
        salary: {},
        charge: {},
        openUpdate: "", 
        selected: {},
    }
 
    findPayments = () => {
        const { PAYMENT_DETAILS, SPENDINGS, CATEGORIES, CHARGES, SALARIES, SALARY_CATS, payment, SUPPLIERS, USERS } = this.props;
        let payments = []
        Object.values(PAYMENT_DETAILS).forEach( item => {
            if (item.payment_info_id === payment.payment_id){
                let spending = {}
                let salary = {}
                let charge = {}
                let category = {}
                let supplier = {}
                let categoryParent = ""

                if ( item.payment_is_charge ) {
                    charge = CHARGES[item.payment_charge_id]
                    category =  CATEGORIES.CHILD[SALARY_CATS[charge.salary_line_name].salary_cat_parent]
                    categoryParent = CATEGORIES.PARENT[category.category_parent].category_name

                } else if ( item.payment_is_salary ) {
                    salary = SALARIES[item.payment_salary_id]
                    // category =  CATEGORIES.CHILD[salary.salary_category]

                } else if ( item.payment_spending_id ) {
                    spending = SPENDINGS[item.payment_spending_id]
                    supplier =  SUPPLIERS[spending.spending_supplier]
                    category =  CATEGORIES.CHILD[spending.spending_category]
                    categoryParent = CATEGORIES.PARENT[category.category_parent].category_name

                    
                } else if(item.payment_supplier_advance){ // paid with advance // not used
                    console.log("supplier", item.payment_details_supplier, SUPPLIERS[item.payment_details_supplier]);
                    spending = SPENDINGS[item.payment_spending_id]
                    supplier = SUPPLIERS[item.payment_details_supplier]
                    category = supplier && supplier.supplier_name
                    spending.spending_desc = "Paiement par ACOMPTE"
                    
                } else if(item.payment_is_supplier_advance){ // advance to supplier
                    console.log("supplier", item.payment_details_supplier, SUPPLIERS[item.payment_details_supplier]);
                    spending.spending_date = item.payment_details_date
                    supplier = SUPPLIERS[item.payment_details_supplier]
                    category = supplier && supplier.supplier_name
                    spending.spending_desc = "ACOMPTE"
                // } else if(item.payment_is_avance){
                //     console.log("collab", item.payment_details_collaborator, USERS[item.payment_details_collaborator]);
                //     let user = Object.assign({}, USERS[item.payment_details_collaborator])
                //     collaborator = `${user.username} ${user.lastname}`
                //     spending.spending_desc = "AVANCE"
                    
                }
                let payDetail = Object.assign({spending, charge, salary, category, categoryParent, supplier}, item)

                payments.push(payDetail)
            }
        })
        
        this.setState({
            payments
        })
    }
    render() {
        const { payment, PAYMENT_DETAILS, SPENDINGS, BANKS, SUPPLIERS, LABELS, PAYMENTS, CATEGORIES, SALARY_CATS, EMPLOYEES } = this.props;
        const { payments, openSpending, spending, openUpdate, selected } = this.state;
        if ( !isEmpty(PAYMENT_DETAILS) && !isEmpty(SPENDINGS) && isEmpty(payments)) {
            this.findPayments()
        }
        console.log('====================================');
        console.log({payments});
        console.log('====================================');
        return (
            <Dialog
                // disableBackdropClick
                open={true}
                onClose={this.props.handleClose}
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth="md"
                scroll="body"
            >
                {openSpending && spending && 
                    <SpendingDetails 
                        supplier={SUPPLIERS && SUPPLIERS[spending.spending_supplier]} 
                        LABELS={LABELS}
                        BANKS={BANKS}
                        PAYMENTS={PAYMENTS}
                        category={CATEGORIES.CHILD && CATEGORIES.CHILD[spending.spending_category]} 
                        spending={spending} 
                        view="ADMIN"
                        handleClose={()=> this.setState({ openSpending: false, spending: {} })}
                        fetchSpendingPayments={this.props.fetchSpendingPayments}
                    />
                }
                {/* {openUpdate && !isEmpty(selected) &&
                    <PaymentUpdate
                        update 
                        payment={selected} 
                        spendings={payments}
                        open={openUpdate} 
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                } */}
                <DialogTitle id="form-dialog-title" >
                {/* <DialogTitle id="form-dialog-title" style={{backgroundColor: "#ffd54f" }} > */}
                    <IconButton color="inherit" onClick={this.props.handleClose} aria-label="Close">
                        <ArrowBack /> 
                    </IconButton>
                    Paiement n° {payment.payment_ref}
                </DialogTitle>
                <Divider />
                <br/>
                <DialogContent>
                    {/* {payment.payment_mode !== "COLLAB" &&
                        <Box style={{ textAlign: "right"}}>
                            <Button 
                                variant="contained" 
                                onClick={
                                    () => this.setState({openUpdate: true, selected: payment})
                                } 
                                color="secondary"
                            >
                                <FormattedMessage id="form.update" defaultMessage="Modifier" />
                            </Button>
                        </Box>
                    } */}
                    <Grid container spacing={2}>
                        <Grid item xs={12} container spacing={2}>
                            <Grid item xs={6}>Date de Paiement</Grid>
                            <Grid item xs={6}>{new Date(payment.payment_date).toLocaleDateString("fr-FR")}</Grid>
                        </Grid>
                        <Grid item xs={12} container spacing={2}>
                            <Grid item xs={6}>Banque</Grid>
                            <Grid item xs={6}>{BANKS[payment.payment_bank].bank_name}</Grid>
                        </Grid>
                        <Grid item xs={12} container spacing={2}>
                            <Grid item xs={6}>Mode de Paiement</Grid>
                            <Grid item xs={6}>{payment.payment_mode}</Grid>
                        </Grid>
                        <Grid item xs={12} container spacing={2}>
                            <Grid item xs={6}>Total</Grid>
                            <Grid item xs={6}><Currency value={payment.payment_total_amount} /></Grid>
                        </Grid>
                        <Grid item xs={12} container spacing={2}>
                            <Grid item xs={6}>Remarques</Grid>
                            <Grid item xs={6}>{payment.payment_remarks}</Grid>
                        </Grid>
                    </Grid>
                    <br/>
                    <Divider />
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={5} style={{textAlign: "center", fontWeight: "700"}}>Dépenses</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!isEmpty(payments) &&
                                payments.map(pay => (
                                    <Fragment>
                                        {!isEmpty(pay.spending) &&
                                            <TableRow
                                                hover
                                                className="clickable" 
                                                key={pay.payment_info_id} 
                                                onClick={ () => this.setState({ 
                                                    openSpending: pay.spending.spending_id && true, 
                                                    spending: pay.spending.spending_id && pay.spending 
                                                }) }
                                            >
                                                <TableCell>
                                                    {new Date(pay.spending.spending_date).toLocaleDateString("fr-FR")}
                                                </TableCell>
                                                <TableCell>
                                                    <b>{pay.spending.spending_desc}</b>
                                                    {/* <i>{pay.categoryParent}</i> > <b>{pay.category.category_name}</b> */}
                                                </TableCell>
                                                <TableCell>
                                                    <i>{pay.supplier.supplier_name}</i>
                                                </TableCell>
                                                <TableCell><Currency value={pay.payment_amount} /></TableCell>
                                            </TableRow>
                                        }
                                        {!isEmpty(pay.charge) &&
                                            <TableRow
                                                hover
                                                className="clickable" 
                                                key={pay.payment_info_id} 
                                                onClick={ () => this.setState({ 
                                                    openCharge: true, 
                                                    charge: pay.charge 
                                                }) }
                                            >
                                                <TableCell>
                                                    {new Date(pay.charge.salary_line_date).toLocaleDateString("fr-FR")}
                                                </TableCell>
                                                <TableCell>
                                                    <b>
                                                        {SALARY_CATS && pay.charge.salary_line_name && 
                                                            SALARY_CATS[pay.charge.salary_line_name].salary_cat_name
                                                        }
                                                    </b>
                                                    {/* <i>{pay.categoryParent} > {pay.category.category_name}</i> > <b>
                                                        {SALARY_CATS && pay.charge.salary_line_name && 
                                                            SALARY_CATS[pay.charge.salary_line_name].salary_cat_name
                                                        }
                                                    </b> */}
                                                </TableCell>
                                                <TableCell>
                                                    { pay.charge.salary_line_employee && 
                                                        EMPLOYEES[pay.charge.salary_line_employee].employee_lastname
                                                    } { pay.charge.salary_line_employee && 
                                                        EMPLOYEES[pay.charge.salary_line_employee].employee_firstname
                                                    }
                                                </TableCell>
                                                <TableCell><Currency value={pay.payment_amount} /></TableCell>
                                            </TableRow>
                                        }
                                        {!isEmpty(pay.salary) &&
                                            <TableRow
                                                hover
                                                className="clickable" 
                                                key={pay.payment_info_id} 
                                                onClick={ () => this.setState({ 
                                                    openCharge: true, 
                                                    charge: pay.charge 
                                                }) }
                                            >
                                                <TableCell>
                                                    {new Date(pay.salary.salary_date).toLocaleDateString("fr-FR")}
                                                </TableCell>
                                                <TableCell>
                                                    <b>
                                                        Salaire { MONTHS[new Date(pay.salary.salary_period_end).getMonth()]} {new Date(pay.salary.salary_period_end).getFullYear() }
                                                    </b>
                                                </TableCell>
                                                <TableCell>
                                                    <i>
                                                        {pay.salary.salary_employee && 
                                                            EMPLOYEES[pay.salary.salary_employee].employee_lastname
                                                        } { pay.salary.salary_employee && 
                                                            EMPLOYEES[pay.salary.salary_employee].employee_firstname
                                                        }
                                                    </i>
                                                    
                                                </TableCell>
                                                <TableCell><Currency value={pay.payment_amount} /></TableCell>
                                            </TableRow>
                                        }

                                    </Fragment>
                                ))
                            }

                        </TableBody>
                    </Table>
                    
                </DialogContent>
                {/* <DialogActions>
                    <Button variant="contained" onClick={this.handleSubmit} color="secondary">
                        <FormattedMessage id="form.update" defaultMessage="Modifier" />
                    </Button>
                    
                </DialogActions> */}
            </Dialog>
        );
    }
}

export default PaymentDetails;